<template>
  <!--
      作者 huangyi
      时间：2023-05-19
      描述：设置-上传设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--文件上传设置-->
      <div class="common-form">提现手续费设置</div>
      <div>
        <el-form-item label="最低提现金额：">
          <el-input type="number" :min="0.01" :step="0.01" v-model="form.withdraw.minMoney" style="width: 200px;"></el-input> ￥
        </el-form-item>
        <el-form-item label="类型：">
          <div>
            <el-radio v-model="form.withdraw.type" label="Pen" @change="getRadio">按笔</el-radio>
            <el-radio v-model="form.withdraw.type" label="Ratio" @change="getRadio">按比例</el-radio>
            <el-radio v-model="form.withdraw.type" label="RatioAndPen" @change="getRadio">按比例和笔</el-radio>
          </div>
        </el-form-item>
        <div v-if="this.form.withdraw.type == 'Pen'">
          <el-form-item label="金额：">
            <el-input type="number" :min="0.01" :step="0.01" v-model="form.withdraw.money" style="width: 200px;"></el-input> ￥
          </el-form-item>
        </div>
        <div v-if="this.form.withdraw.type == 'Ratio'">
          <el-form-item label="比例：">
            <el-input type="number" :min="0.01" :step="0.01" v-model="form.withdraw.proportion" style="width: 200px;"></el-input> %
          </el-form-item>
        </div>
        <div v-if="this.form.withdraw.type == 'RatioAndPen'">
          <el-form-item label="比例：">
            <el-input type="number" :min="0.01" :step="0.01" v-model="form.withdraw.proportion" style="width: 200px;"></el-input> %
          </el-form-item>
          <el-form-item label="金额：">
            <el-input type="number" :min="0.01" :step="0.01" v-model="form.withdraw.money" style="width: 200px;"></el-input> ￥
          </el-form-item>
        </div>
        <el-form-item label="提现时间：">
          <el-input type="number" :min="0" :max="23" :step="1" v-model="startHour" style="width: 50px;"></el-input> 时
          <el-input type="number" :min="0" :max="59" :step="1" v-model="startSec" style="width: 50px;"></el-input> 分
          ~
          <el-input type="number" :min="0" :max="23" :step="1" v-model="endHour" style="width: 50px;"></el-input> 时
          <el-input type="number" :min="0" :max="59" :step="1" v-model="endSec" style="width: 50px;"></el-input> 分
        </el-form-item>
        <el-form-item label="提现说明：">
          <el-input v-model="form.withdraw.explain" type="textarea" :rows="4" style="width: 280px;"></el-input>
        </el-form-item>
      </div>
      <div class="common-form">提现配置接收验证码手机号</div>
      <el-form-item label="手机号码：">
          <el-input type="text"  v-model="form.phone" style="width: 200px;"></el-input>
        </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        withdraw: {
          minMoney:'',        // 最低提现金额
          type:'',            // 类型 Pen:笔  Ratio:比例   RatioAndPen:按比例和笔
          money:'',           // 金额
          proportion:'',      // 比例
          startTime:'',       // 提现开始时间
          endTime:'',          // 提现结束时间
          explain:''          // 提现说明
        },
        phone:''
      },
      startHour:'', // 开始时
      startSec:'',  // 开始分
      endHour:'',   // 结束时
      endSec:'',    // 结束分
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.withdrawDetail({}, true)
        .then(res => {
          self.form.withdraw = res.data.withdraw;
          if ( null != res.data && null != res.data.withdraw && null != res.data.withdraw.startTime && null != res.data.withdraw.endTime
              && undefined != res.data && undefined != res.data.withdraw && undefined != res.data.withdraw.startTime && undefined != res.data.withdraw.endTime){
            this.startHour = res.data.withdraw.startTime.split(":")[0]
            this.startSec = res.data.withdraw.startTime.split(":")[1]
            this.endHour = res.data.withdraw.endTime.split(":")[0]
            this.endSec = res.data.withdraw.endTime.split(":")[1]
          }
          SettingApi.getWithdrawVerify({}, true)
        .then(res => {
          console.log(res)
          self.form.phone = res.data.phone;

        })
        .catch(error => {});
        })
        .catch(error => {});

    },
    //提交表单
    onSubmit() {

      // 校验
      let verify = this.verify();
      if (verify){
        return;
      }
      let self = this;
      if(!self.form.phone){
        self.$message({
            message: '请输入手机号码',
            type: 'warning'
          });
          return
      }
      const reg = /^1[0-9]{10}$/; // 手机号正则表达式
      if (!reg.test(self.form.phone)) {
        self.$message({
            message: '手机号码格式错误',
            type: 'warning'
          });
        return
      }

      self.loading = true;
      let params = this.form;
      let withdraw = params.withdraw;
      if (withdraw.type == "Pen"){
        withdraw.proportion = "";
      }else if (withdraw.type == "Ratio") {
        withdraw.money = "";
      }
      withdraw.startTime = this.startHour +":"+ this.startSec
      withdraw.endTime = this.endHour +":"+ this.endSec
      console.log(params)
      const phone = params.phone
      SettingApi.saveWithdrawVerify({
        phone:phone
      }, true)
        .then(data => {
          SettingApi.editWithdraw(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '设置成功',
            type: 'success'
          });
          self.getData()
        })
        .catch(error => {
          self.loading = false;
        });
        })
        .catch(error => {
          self.loading = false;
        });

    },
    //监听单选按钮
    getRadio(val) {
    },

    //提交校验
    verify() {
      let withdraw = this.form.withdraw;
      if ('' == withdraw.minMoney){         // 最低提现金额
        this.$message.error('最低提现金额不能为空!');
        return true;
      }else if ('' == withdraw.type){       // 类型
        this.$message.error('类型不能为空!');
        return true;
      }else if ('Pen' == withdraw.type && '' == withdraw.money){
        this.$message.error('金额不能为空!');
        return true;
      }else if ('Ratio' == withdraw.type && '' == withdraw.proportion){
        this.$message.error('比例不能为空!');
        return true;
      } else if ('' == this.startHour || '' == this.startSec || '' == this.endHour || '' == this.endSec){       // 提现时间
        this.$message.error('提现时间不能为空!');
        return true;
      }else if ('' == withdraw.explain){
        this.$message.error('提现说明不能为空!');
        return true;
      }
      return false;
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/withdraw/index.vue